export const Api = {
  BASE_URL: `http://localhost:3000/api/v1`
};
